<template>
	<div class="root">
		<MeetingHeader/>
		<div class="container">
			<TopBar style='padding: 0 10px;margin-bottom:20px;'/>
			<div class="info">
				<div class="appointment-info">
					<h3>预约信息<span v-if='storeName'>-{{storeName}}</span></h3>
					<table class="table" cellspacing="0" cellpadding="0">
						<tr>
							<td></td>
							<td>日期</td>
							<td>预约时段</td>
							<td>金额</td>
							<td>工具包数量</td>
						</tr>
						<tr v-for='(item,cartIndex) in cart' :key="cartIndex" :class="{Reserved:item.Reserved}">
							<td>{{ item.IsRoom ? item.RoomName : `${item.ProductName}&nbsp;×&nbsp;${item.Qty}` }}</td>
							<td>{{item.IsRoom ? item.BookingDate : ''}}</td>
							<td><span v-if='item.BeginTime'>{{item.BeginTime}} - {{item.EndTime}}</span></td>
							<td class="money">￥{{item.Amount}}</td>
							<td class="other"><div :class="getOrderStatusStr('tag',item.OrderStatus)" v-if="!orderStatus(item,'unpay')">{{ getOrderStatusStr('text',item.OrderStatus) }}</div></td>
						</tr>
						<tr v-for='(item,othersIndex) in others'>
							<td class="othersName" colspan="3">
								<div>{{item.RoomName}}{{item.Name}}</div>
								<div class="desc">{{item.Description}}</div>
							</td>
							<td class="money">￥{{item.Price}}</td>
							<td>
								<div class="buy-tool">
									<div @click='modifyOther(item,-1)' class='tool-btn' type='text'><Icon type="md-remove" /></div>
									<div class="number">{{item.num||0}}</div>
									<div @click='modifyOther(item,1)' class='tool-btn' type='text'><Icon type="md-add" /></div>
								</div>
							</td>
						</tr>
					</table>
				</div>
				<div class="price-info">
					<div class="total">
						<h4>应付总金额：</h4>
						<div class="price">￥{{amount}}</div>
					</div>
					<div class="tips">
						<p style="margin-top: 10px;"><span style="color:#B176C5;">限时取消：</span>截止预约日期三日前24点，可自主免费取消预约，款项原路退回；超时限后不再接受取消，如未出席仍视为占用。</p>
						<!-- <p style="margin-top: 10px;"><span style="color:#B176C5;">注意事项：</span>如取消，该笔预约订单内所有预约时间段将一并取消，不支持部分取消。</p> -->
						<!-- <p style="margin-top: 10px;"><span style="color:#B176C5;">收费方式：</span>先预约使用，次月服务费税前结算抵扣</p> -->
					</div>
				</div>
				<div class='buyer'>
					<h4>预约人</h4>
					<div class="name">
						<div class="label">姓名<span>*</span></div>
						<input placeholder="请填写联系人" class='input' :class='{error:error.name}' v-model='name' maxlength='80' @blur='checkName' :disabled="disabled" />
						<p class="error" v-if='error.name'>{{error.name}}</p>
					</div>
					<div class="phone">
						<div class="label">联系方式<span>*</span></div>
						<input placeholder="请填写联系电话" class='input' :class='{error:error.phone}' v-model='phone' @blur='checkPhone' :disabled="disabled" />
						<p class="error" v-if='error.phone'>{{error.phone}}</p>
					</div>
					<div class="remark">
						<div class="label">房间准备要求</div>
						<Input :autosize='{minRows: 4}' maxlength='300' type='textarea' placeholder="如:布置会议室安排投影仪等" v-model='remark' :disabled="disabled" />
					</div>
				</div>
			</div>
			<div class="bottom">
				<Button @click='goPay' size='large' class='pay-btn' type='primary' :loading="loading">确认预约</Button>
			</div>
		</div>
		<Modal v-model="modal" title="当前用户非VIpBiz，请填写代缴账户" >
			<div slot="footer">
				<Button type="primary" ghost @click="modal = false">取消</Button>
				<Button type="primary" @click="provingVip('formInline')">确定</Button>
			</div>
			<Form ref="formInline" :model="formInline" :rules="ruleInline"  :label-width="80">
				<FormItem label="代缴账户" prop="VipNo">
					<Input type="text" v-model="formInline.VipNo" placeholder="请填写代缴账户" ></Input>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="modalSelected" width="800">
			<div>
				<h3 class="modalSelectedH3">您选择的以下时间段已被预约，是否直接删除，并继续提交订单</h3>
				<table class="table" cellspacing="0" cellpadding="0">
					<tr>
						<td></td>
						<td>日期</td>
						<td>预约时段</td>
						<td>金额</td>
						<td>工具包数量</td>
					</tr>
					<tr v-for='(item,cartIndex) in cart.filter(obj=>obj.Reserved)' :key="cartIndex">
						<td>{{ item.IsRoom ? item.RoomName : `${item.ProductName}&nbsp;×&nbsp;${item.Qty}` }}</td>
						<td>{{item.IsRoom ? item.BookingDate : ''}}</td>
						<td><span v-if='item.BeginTime'>{{item.BeginTime}} - {{item.EndTime}}</span></td>
						<td>￥{{item.Amount}}</td>
						<td><div :class="getOrderStatusStr('tag',item.OrderStatus)" v-if="!orderStatus(item,'unpay')">{{ getOrderStatusStr('text',item.OrderStatus) }}</div></td>
					</tr>
				</table>
			</div>
			<div slot="footer">
				<Button type="primary" ghost @click="goPay('back')">否，返回重新勾选</Button>
				<Button type="primary" @click="goPay('reserved')">是，下一步</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import MeetingHeader from '@/components/header/MeetingHeader'
	import TopBar from '@/components/common/TopBar'
	import {RE_PHONE} from '@/components/common/regex'
	export default {
		data() {
			return {
				phone:'',
				name:'',
				remark:'',
				error:{
					phone:'',
					name:'',
				},
				storeName:'',
				cart:[],
				others:[],
				loading:false,
				
				modal:false,
				modalSelected:false,
                formInline: {
                    VipNo: '',
                },
                ruleInline: {
					VipNo: [
                        { required: true, message: '请填写代缴账户', trigger: 'blur' }
                    ],
                },
				paySwitch:false,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			phone(){
				this.error.phone = ''
			},
			name(){
				this.error.name = ''
			}
		},
		mixins:[],
		components: {
			MeetingHeader,
			TopBar
		},
		computed: {
			...mapState({
				userInfo:state=>state.common.userInfo,
				openid:state=>state.common.openid,
				channel:state=>state.common.channel,
				wechatUserInfo: state => state.common.wechatUserInfo.value.binding,
			}),
			amount(){
				const cartSum = this.cart.filter(item => item.OrderStatus?.toLowerCase() == 'unpay').reduce((total, item) => total + (item.Amount || 0), 0);
				const othersSum = this.others.reduce((total, item) => total + (item.Price || 0) * (item.num || 0), 0);
				return cartSum + othersSum;
			},
			disabled(){
				return this.$route.query?.code ? true : false
			}
		},
		methods: {
			...mapActions([
				'getReservationCartAction',
				'getReservationDetailAction',
				'postReservationAdditionalAction',
				'getReservationOrdersAction',
				'postDeterminePaymentuserAction',
				'postReservationRoomsAction',
				'getPaySwitchAction'
			]),
			orderStatus(item,status){
				return item.OrderStatus?.toLowerCase() == status
			},
			getOrderStatusStr(val,status){
				const statusTag = {
					cancel:'cancel',
					pay:'success',
					complete:'warning',
					used:'warning'
				}
				const statusStr = {
					cancel:'已取消',
					pay:'已支付',
					complete:'已确认',
					used:'已使用'
				}
				if(val == 'tag') return statusTag[status?.toLowerCase()]
				if(val == 'text') return statusStr[status?.toLowerCase()]
			},
			async initData() {
				let ss_021 = await this.getPaySwitchAction()
				this.paySwitch = ss_021 == 1 // 切换为直接支付

				this.phone = this.userInfo?.MobilePhone ?? '';
				this.name = this.userInfo?.Name ?? '';
				let RoomIds = [];
				let cartData = [];
				// 个人中心进入
				if (this.$route.query?.code) {
					// const ss_006 = await this.getReservationOrdersAction({
					// 	BookingId:this.$route.query?.code
					// })
					// const orderStatus = ss_006[0]?.OrderStatus
					// if (orderStatus == 'Pay') {
					// 	this.$router.replace('/meeting/orders')
					// 	return
					// }
					const ss_007 = await this.getReservationDetailAction({
						BookingId: this.$route.query.code,
					});
					if (Array.isArray(ss_007) && ss_007.length) {
						cartData = ss_007;
						this.phone = ss_007[0].MobilePhone
						this.name = ss_007[0].BookUserName
						this.remark = ss_007[0].Description
					}
				} else {
					// 初次提交进入
					const checkRooms = JSON.parse(sessionStorage.getItem('checkRooms') || '[]');
					if (checkRooms.length) {
						cartData = checkRooms;
					} else {
						this.$Modal.warning({
							title: '提示',
							content: '信息获取失败，请重新选择。',
							onOk: () => this.$router.push('/meeting/start'),
						});
						return
					}
				}
				// 提取 RoomIds
				RoomIds = [...new Set(cartData.map(item => item.RoomId))];
				this.cart = cartData;
				this.storeName = cartData[0]?.StoreName ?? '';
				// 获取产品
				if (RoomIds.length) {
					const ss_004 = await this.getReservationCartAction({
						// BookingId:this.$route.query?.code
						RoomIds: RoomIds.join(','),
					});
					if (Array.isArray(ss_004) && ss_004.length) {
						this.others = ss_004;
					}
				}
				
			},
			checkPhone(){
				this.error.phone = ''
				if (!this.phone) {
					this.error.phone = '请填写联系电话'
					return false
				}
				if (!RE_PHONE.test(this.phone)) {
					this.error.phone = '请填写正确的手机号码'
					return false	
				}
				return true
			},
			checkName(){
				this.error.name = ''
				if (!this.name) {
					this.error.name = '请填写联系人'
					return false
				}
				return true
			},
			modifyOther(item,factor) {
				if (!item.num && factor == 1) {
					item.num = 1;
				} else {
					if(item.num) item.num += factor
				}
				
				this.others = [...this.others]
			},
			getChannel(){
				let channel = '';
				if(this.openid){
					channel = 'am'
				}else if(navigator.userAgent.indexOf('com.doterra.app') != -1 || navigator.userAgent.indexOf('DTBusiness') != -1){
					channel = 'app'
				}else{
					channel = 'myo'
				}
				return channel
			},
			provingVip(name){
                this.$refs[name].validate(async (valid) => {
                    if (valid) {
						let SS_018 = await this.postDeterminePaymentuserAction({VipNo:this.formInline.VipNo})
						if (SS_018.isVIPBiz == 1) {
							this.modal = false
							// this.$Message.success('验证成功');
							// this.reservationAdditional()
							const hasCode = !!this.$route.query?.code;
							if (hasCode) {
								this.reservationAdditional(); // 个人中心进入，追加
							} else {
								this.goConfirm();
							}
						} 
						if(SS_018.isVIPBiz == 0){
							this.$Message.info('该账号不得作为服务费代扣账号，请重新填写。');
						}
						if (SS_018.isVIPBiz == -1) {
							this.$Message.error('未找到该用户,请确定用户存在后再次填写。');
						}
						if (SS_018.isVIPBiz == 2) {
							this.$Message.error('该用户已中止，请重新填写。');
						}

                    }
                })
			},
			goPay(val) {
				if (val === 'back') return this.$router.go(-1);

				const isPhoneValid = this.checkPhone();
				const isNameValid = this.checkName();
				if (!isPhoneValid || !isNameValid) return;

				const hasCode = !!this.$route.query?.code;
				const isVipBiz = this.wechatUserInfo.customer_type?.toLowerCase() == 'vipbiz';

				// 为服务费代扣，且非VIpBiz用户
				if (!this.paySwitch && !isVipBiz) {
					this.formInline.VipNo = ''
					this.modal = true
					return
				}

				// 确定下一步操作
				if (hasCode) {
					this.reservationAdditional(val); // 个人中心进入，追加
				} else {
					this.goConfirm(val);
				}
			},
			// 获取 最小日期 和 最大日期
			getDateRange(list, key = 'BookingDate') {
				let min = ''
				let max = ''
				list.forEach(item => {
					if (item[key]) {
						const d = new Date(item[key])
						if (!min || d < new Date(min)) min = item[key]
						if (!max || d > new Date(max)) max = item[key]
					}
				})
				return { min, max }
			},
			// 订单提交
			async goConfirm(val) {
				if (this.loading) return
				let Rooms = []
				const { min: BookingDateMin, max: BookingDateMax } = this.getDateRange(this.cart)
				this.cart.forEach(item=>{
					Rooms.push(
						{
							IsRoom:1,
							RoomId:item.RoomId,
							ProductId:0,
							Price:item.Price,
							Qty:1,
							Amount:item.Price,
							Discount:0,
							BookingDate:item.BookingDate,
							TimeRangeId:item.TimeRangeId,
						},
					)
				})
				let Others = []
				this.others.filter(item=>item.num).map(item=>{
					Others.push(
						{
							IsRoom:0,
							RoomId:item.RoomId,
							ProductId:item.ID,
							Price:item.Price,
							Qty:item.num,
							Amount:item.Price * item.num,
							Discount:0,
							BookingDate:BookingDateMin,
							TimeRangeId:0,
						}
					)
				})
				// 直接删除提交
				if (Rooms.length && val == 'reserved') {
					// 过滤出 Reserved 中不存在的房间
					Rooms = Rooms.filter(item =>
						!this.Reserved.has(`${item.RoomId}-${item.TimeRangeId}-${item.BookingDate}`)
					)
					// 过滤产品
					if (Others.length) {
						// 保留 RoomId 存在于 Others 的产品
						const RoomsID = new Set(Rooms.map(obj => obj.RoomId))
						Others = Others.filter(obj => RoomsID.has(obj.RoomId))
					}
				}
				if(!Rooms.length){
					this.$Modal.warning({
						title: '提示',
						content: '请选择您要预约的会议室。',
						onOk: () => this.$router.push('/meeting/start'),
					});
					return;
				}
				let params = {
					OrderChannel:this.getChannel(),
					StoreId:this.$route.query?.storeId,
					OrderStatus:this.paySwitch ? 'UnPay' : 'Pay',
					Amount:this.amount,
					TotalPaid:this.amount,
					Discount:0,
					BookUserName:this.name,
					MobilePhone:this.phone,
					Description:this.remark,
					WithholdAccount:this.formInline.VipNo, // 代扣账户
					Rooms:[...Rooms,...Others],
					place:'list',
				}
				this.loading = true
				let ss_003 = await this.postReservationRoomsAction(params)
				this.loading = false
				if (typeof ss_003?.Value == 'string' && ss_003?.Reserved?.length) {
					this.Reserved = new Set(
						ss_003?.Reserved.map(obj => `${obj.RoomId}-${obj.TimeRangeId}-${obj.BookingDate}`)
					)
					this.cart.forEach(item =>{
						if(this.Reserved.has(`${item.RoomId}-${item.TimeRangeId}-${item.BookingDate}`)) item.Reserved = 1
					})
					this.modalSelected = true
				} else if(typeof ss_003?.Value == 'string'){
					this.$Modal.info({
						title:'提示',
						content:ss_003?.Value,
					})
				} else if(ss_003 == -1) {
					this.$Modal.error({
						title:'错误',
						content:'提交异常，请稍后重试',
					})
				}  else {
					if(this.paySwitch){
						this.$router.push(`/meeting/payment?code=${ss_003?.Value}`)
					}else{
						this.$Modal.success({
							title:'预约成功',
							content:'恭喜您，预约成功！期待您准时香约！',
							onOk:()=>{
								this.$router.push('/meeting/orders')
							}
						})
					}
				}
			},
			// 提交追加
			async reservationAdditional(){
					if (this.loading) return
				    // let valid1 = this.checkPhone() 
				    // let valid2 = this.checkName()
				    // if (!valid1 || !valid2) return
					
				    this.loading = true
					const { min: BookingDateMin, max: BookingDateMax } = this.getDateRange(this.cart)
				    let params = {
						OrderChannel:this.getChannel(),
				        BookingId:this.$route.query?.code,
					    OrderStatus:'Pay',
					    Amount:this.amount,
					    TotalPaid:0,
					    Discount:0,
						BookUserName:this.name,
						MobilePhone:this.phone,
						Description:this.remark,
						WithholdAccount:this.formInline.VipNo,
					    Rooms:this.others.filter(item=>item.num).map(item=>{
						    return {
							    IsRoom:0,
							    RoomId:item.RoomId,
							    ProductId:item.ID,
							    Price:item.Price,
							    Qty:item.num,
							    Amount:item.Price * item.num,
							    Discount:0,
							    BookingDate:BookingDateMin,
							    TimeRangeId:0,
						    }
					}),
				}
				if(!params.Rooms.length){
					this.loading = false
					this.$Modal.warning({
						title:'提示',
						content:'请选择您要追加的产品。',
					})
					return
				}
				let ss_005 = await this.postReservationAdditionalAction(params)
				this.loading = false
				if (typeof ss_005?.Value == 'string') {
					this.$Modal.info({
						title:'提示',
						content:ss_005?.Value,
					})
				} else if(ss_005 == -1) {
					this.$Modal.error({
						title:'错误',
						content:'提交异常，请稍后重试',
					})
				}  else {
					if(this.paySwitch){
						this.$router.push(`/meeting/payment?code=${ss_005?.Value}`)
					}else{
						this.$Modal.success({
							title:'追加成功',
							content:'恭喜您，追加成功！期待您准时香约！',
							onOk:()=>{
								this.$router.push('/meeting/orders')
							}
						})
					}
					// this.$router.push(`/meeting/payment?code=${this.$route.query?.code}`)
				}
				// if (ss_005?.Value == 1) {
				// 	this.$Modal.success({
				// 		title:'预约成功',
				// 		content:'恭喜您，预约成功！期待您准时香约！',
				// 		onOk:()=>{
				// 			this.$router.push('/meeting/orders')
				// 		}
				// 	})
				// } else if (typeof ss_005?.Value == "string") {
				// 	this.$Modal.error({
				// 		title:'提示',
				// 		content:ss_005?.Value,
				// 		onOk:()=>{
				// 		}
				// 	})
				// }
			}
			
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.error {
		color:red;
	}
	.root {
		display:block;
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1rem;
		margin:auto;
		max-width: 1400px;
	}
	.info {
		padding: 20px;
		background-color: white;
		border-radius: 20px;
		h3 {
			@include fontSize($font-size-30);
			font-weight: normal;
			margin-bottom: 20px;
			border-bottom: 1px dashed #aaa;
		}
		.price-info {
			.price-item {
				display:flex;
				justify-content: space-between;
				@include fontSize($font-size-16);
				margin-bottom: 10px;
				.price {
					font-weight: bold;
				}
			}
			.total {
				display:flex;
				align-items: center;
				margin-top: 20px;
				h4 {
					@include fontSize($font-size-20);
					margin-bottom: 0;
				}
				.price {
					font-weight: bold;
					color:red;
					@include fontSize($font-size-24);
				}
			}
			.tips {
				margin-top: 10px;
			}
		}
		.buyer {
			border-top: 1px dashed #aaa;
			margin-top: 20px;
			padding-top: 10px;
			h4 {
				@include fontSize($font-size-20);
			}
			.name,.phone,.remark {
				margin-top: 20px;
				.label {
					@include fontSize($font-size-16);
					margin-bottom: 10px;
					display:flex;
					align-items: center;
					.checkbox {
						margin-left: 20px;
					}
					span {
						color:red;
					}
				}
				.input {
					border:none;
					outline:none;
					color:$theme-color;
					width:200px;
					@include fontSize($font-size-16);
					border-bottom: 1px solid $theme-color;
				}
				input.error {
					border-bottom: 1px solid red;
				}
			}
		}
	}
	.bottom {
		text-align: center;
		.pay-btn {
			margin:30px 0;
			height:44px;
			width:360px;
			border-radius: 30px;
		}
	}
	.modalSelectedH3{
		@include fontSize($font-size-18);
		font-weight: normal;
		margin-bottom: 10px;
		border-bottom: 1px dashed #aaa;
		padding-right: 20px;
	}
	.table{
		width: 100%;
		overflow: hidden;
		text-align: center;
		@include fontSize($font-size-16);
		tr{
			width: 100%;
			display: flex;
			margin: 4px 0px;
			background-color: #ffffff;
			td{
				width: auto;
				flex: 1;
				padding: 6px 0px;
				.buy-tool {
					flex:1;
					display:flex;
					align-items: center;
					justify-content: center;
					.number {
						box-shadow: 3px 8px 20px 0px rgba(0,0,0,0.1);
						text-align: center;
						width:40px;
						height:40px;
						display:flex;
						align-items: center;
						justify-content: center;
						margin:0 10px;
						border-radius: 20px;
						color:$theme-color;
						font-weight: bold;
						@include fontSize($font-size-20);
					}
					.tool-btn {
						cursor: pointer;
						display:flex;
						align-items: center;
						justify-content: center;
						width:30px;
						height:30px;
						border:1px solid $theme-color;
						color:$theme-color;
						font-size: 20px;
					}
				}
			}
			td:first-child{
				flex: 2;
				text-align: left;
			}
			td.othersName{
				flex: 4;
				// color:$theme-color;
				.desc {
					font-size: 13px;
					color:#999;
					margin-top: 3px;
				}
			}
			.money {
				color:red;
			}
			.other{
				display: flex;
				justify-content: center;
				.cancel,.success,.warning{
					@include fontSize($font-size-12);
					width:60px;
					color: $theme-color;
					border:1px solid $theme-color;
					text-align: center;
					border-radius: 20px;
					height: 20px;
					line-height: 20px;
				}
				.success{
					color: $success-color;
					border:1px solid $success-color;
				}
				.warning{
					color: $warning-color;
					border:1px solid $warning-color;
				}
				.cancel{
					cursor: no-drop;
					color: #c5c8ce;
					border-color: #dcdee2;
				}
			}
		}
		tr:not(:first-child){
			td:nth-child(3){
				color:$theme-color;
			}
		}
		tr.Reserved{
			padding: 0 10px;
			border: 2px solid red;
		}
	}
	@media (max-width: 768px){
		.container {
			padding-top: 2.4rem;
		}
		.bottom {
			text-align: center;
			.pay-btn {
				width:90%;
			}
		}
	}
</style>